import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { WizardSteps } from "./WizardSteps";
import { Nextsteps } from "./NextStep";
import warning from "../../assets/icons/warning.png";
import SubjectsModal from "./../../components/modals/Subjects.Modal.js";
import TutoringModeModal from "../../components/modals/TutoringMode.Modal";

export const First = (props) => {
  const [state, setState] = useState({
    subjects: {},
    address: {
      address1: "",
      address2: "",
      apartment: "",
      city: "",
      country: "",
      postCode: "",
    },
    addressRaw: "",
    modeOfTeaching: "",
    willignessToTravel: "",
  });

  useEffect(() => {
    let subjects = props?.TutorInfoObj?.step1?.subjects;
    let modeOfTeaching = props?.TutorInfoObj?.step1?.modeOfTeaching;
    let willignessToTravel = props?.TutorInfoObj?.step1?.willignessToTravel;
    let address = props?.TutorInfoObj?.step1?.address;
    let addressLatLng = props?.TutorInfoObj?.step1?.addressLatLng;
    let addressRaw = props?.TutorInfoObj?.step1?.addressRaw;

    setState((state) => ({
      ...state,
      subjects,
      modeOfTeaching,
      willignessToTravel,
      address,
      addressLatLng,
      addressRaw,
    }));
    if (props.funcStatus === "loading..." && props.currentStep === 1) {
      submitStep1(true);
    }
  }, [props]);

  const isExistObj = () => {
    const { subjects } = state;
    let exist = [];
    if (subjects) {
      Object.keys(subjects).map((subjectObj, title) => {
        return Object.keys(subjects[subjectObj]).map((wSub) =>
          wSub
            ? subjects[subjectObj][wSub].length
              ? subjects[subjectObj][wSub].map((sub) => exist.push(true))
              : exist.push(false)
            : exist.push(false)
        );
      });
      return exist;
    } else return [false];
  };
  const submitStep1 = (isCallApi) => {
    const {
      modeOfTeaching,
      willignessToTravel,
      address,
      addressLatLng,
      addressRaw,
    } = state;
    return isCallApi ? props.AddTutorInfoStepBeforeCallApi("done") : null;
    // return isExistObj().indexOf(true) !== -1 &&
    //   (modeOfTeaching === 0 ||
    //     (willignessToTravel &&
    //       address?.street &&
    //       address?.town &&
    //       address?.country &&
    //       address?.postCode))
    //   ? true
    //   : false;
  };
  const { subjects, modeOfTeaching, willignessToTravel, addressRaw } = state;
  const { iscompletedForm, validationError } = props;

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [modeShow, setModeShow] = useState(false);
  const handleModeClose = () => setModeShow(false);
  const handleModeShow = () => setModeShow(true);

  let color, borderColor, backgroundColor;

  let warningError = (
    <img
      src={warning}
      alt="warning"
      width="14px"
      height="14px"
      style={{ marginRight: "6px" }}
    />
  );

  return (
    <Row className="m-0">
      <SubjectsModal subjectsModal={show} onclose={() => handleClose()} />
      <TutoringModeModal
        tutoringModeModal={modeShow}
        onclose={() => handleModeClose()}
        iscompletedForm={iscompletedForm}
      />
      <WizardSteps step={1} {...props} />
      <Col lg={12} md={12} sm={12} xs={12}>
        <div className="container">
          <Row>
            <Col lg={12} md={12} sm={12} xs={12} className="subject-mode">
              <p className="step-title">
                What subject and level will you teach?
              </p>
              <p className="step-subtitle">
                Choose the subjects and levels that you feel most confident
                tutoring.
              </p>

              {isExistObj().indexOf(true) !== -1 ? (
                <div className="filled-data-card pb-0">
                  {Object.keys(subjects).map((subjectObj, title) => {
                    return Object.keys(subjects[subjectObj]).map(
                      (wSub, index) =>
                        subjects[subjectObj][wSub].length ? (
                          <div key={index}>
                            <label className="label">
                              {wSub.charAt(0).toUpperCase() + wSub.slice(1)}
                            </label>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              {subjects[subjectObj][wSub].map((level, i) => (
                                <span key={i}>{level}</span>
                              ))}
                            </div>
                          </div>
                        ) : null
                    );
                  })}
                  <span className="flex-end-center">
                    <span
                      className="edit-style"
                      onClick={() => handleShow()}
                      style={{
                        marginTop: "-50px",
                      }}
                    >
                      Edit
                    </span>
                  </span>
                </div>
              ) : (
                <div>
                  <label className="labelAdd">Subjects and levels</label>
                  <div
                    className="btn-transparent-outline"
                    onClick={() => handleShow()}
                    style={{
                      color:
                        !isExistObj().indexOf(true) !== -1
                          ? validationError?.data
                            ? "#fa4a4a"
                            : ""
                          : "",
                      borderColor:
                        !isExistObj().indexOf(true) !== -1
                          ? validationError?.data
                            ? "#fa4a4a"
                            : ""
                          : "",
                      backgroundColor:
                        !isExistObj().indexOf(true) !== -1
                          ? validationError?.data
                            ? "#fff1f1"
                            : ""
                          : "",
                    }}
                  >
                    <div
                      className="btn-circle"
                      style={{
                        color:
                          !isExistObj().indexOf(true) !== -1
                            ? validationError?.data
                              ? "#fa4a4a"
                              : ""
                            : "",
                        borderColor:
                          !isExistObj().indexOf(true) !== -1
                            ? validationError?.data
                              ? "#fa4a4a"
                              : ""
                            : "",
                        backgroundColor:
                          !isExistObj().indexOf(true) !== -1
                            ? validationError?.data
                              ? "#fa4a4a"
                              : ""
                            : "",
                      }}
                    >
                      <i
                        className="mdi mdi-plus plusSize"
                        style={{
                          color:
                            !isExistObj().indexOf(true) !== -1
                              ? validationError?.data
                                ? "#ffffff"
                                : ""
                              : "",
                        }}
                      ></i>
                    </div>{" "}
                    Select subjects and levels
                  </div>
                  <div className="error">
                    {!isExistObj().indexOf(true) !== -1
                      ? validationError?.data
                        ? warningError
                        : ""
                      : ""}
                    {!isExistObj().indexOf(true) !== -1
                      ? validationError?.data
                        ? "Please select subjects and levels"
                        : ""
                      : ""}
                  </div>
                </div>
              )}

              <h3 className="step-title" style={{ marginTop: "20px" }}>
                Where should students meet you?
              </h3>
              <p className="step-subtitle">
                Tell parents exactly where you will be teaching your where you
                will be teaching.
              </p>
              {modeOfTeaching || modeOfTeaching === 0 ? (
                <div className="filled-data-card">
                  <label className="label">MODE OF TUTORING</label>
                  <span style={{ display: "flex" }}>
                    {modeOfTeaching === 0
                      ? "On-line"
                      : modeOfTeaching === 1
                      ? "In-person"
                      : modeOfTeaching === 2
                      ? "On-line & In-person"
                      : ""}
                    {!(modeOfTeaching !== 0) ? (
                      <span
                        className="edit-style flex-end-a"
                        onClick={!iscompletedForm ? () => handleModeShow() : ""}
                      >
                        Edit
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                  {modeOfTeaching ? (
                    <label className="label">DISTANCE</label>
                  ) : (
                    ""
                  )}

                  {modeOfTeaching ? (
                    <span className="flex-between-center">
                      {willignessToTravel !== "I only teach at my address"
                        ? `Less than ${willignessToTravel} from`
                        : "I only teach at"}{" "}
                      {addressRaw}
                      <span
                        className="edit-style flex-end-a"
                        onClick={!iscompletedForm ? () => handleModeShow() : ""}
                      >
                        Edit
                      </span>
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <div>
                  <label className="labelAdd">Location</label>
                  <div
                    className="btn-transparent-outline"
                    onClick={() => handleModeShow()}
                    style={{
                      color:
                        !isExistObj().indexOf(true) !== -1
                          ? validationError?.data
                            ? "#fa4a4a"
                            : ""
                          : "",
                      borderColor:
                        !isExistObj().indexOf(true) !== -1
                          ? validationError?.data
                            ? "#fa4a4a"
                            : ""
                          : "",
                      backgroundColor:
                        !isExistObj().indexOf(true) !== -1
                          ? validationError?.data
                            ? "#fff1f1"
                            : ""
                          : "",
                    }}
                  >
                    <div
                      className="btn-circle"
                      style={{
                        color:
                          !isExistObj().indexOf(true) !== -1
                            ? validationError?.data
                              ? "#fa4a4a"
                              : ""
                            : "",
                        borderColor:
                          !isExistObj().indexOf(true) !== -1
                            ? validationError?.data
                              ? "#fa4a4a"
                              : ""
                            : "",
                        backgroundColor:
                          !isExistObj().indexOf(true) !== -1
                            ? validationError?.data
                              ? "#fa4a4a"
                              : ""
                            : "",
                      }}
                    >
                      <i
                        className="mdi mdi-plus plusSize"
                        style={{
                          color:
                            !isExistObj().indexOf(true) !== -1
                              ? validationError?.data
                                ? "#ffffff"
                                : ""
                              : "",
                        }}
                      ></i>
                    </div>{" "}
                    Select your mode of tutoring
                  </div>

                  <div className="error">
                    {!isExistObj().indexOf(true) !== -1
                      ? validationError?.data
                        ? warningError
                        : ""
                      : ""}
                    {!isExistObj().indexOf(true) !== -1
                      ? validationError?.data
                        ? "Please select your mode of tutoring"
                        : ""
                      : ""}
                  </div>
                </div>
              )}
            </Col>
          </Row>
          <Nextsteps step={1} {...props} submitStepInRedux={submitStep1} />
        </div>
      </Col>
    </Row>
  );
};
